import { render } from "./RecoveryTemplate.vue?vue&type=template&id=a9f5669c&scoped=true"
import script from "./RecoveryTemplate.vue?vue&type=script&lang=js"
export * from "./RecoveryTemplate.vue?vue&type=script&lang=js"

import "./RecoveryTemplate.vue?vue&type=style&index=0&id=a9f5669c&scoped=true&lang=css"
import "./RecoveryTemplate.vue?vue&type=style&index=1&id=a9f5669c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\GlavTV\\Documents\\GitHub\\octagon_uz\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9f5669c"]])

export default __exports__